import React from 'react'
import { useRecoilValue } from 'recoil'
import styled from 'styled-components'
import { themeState } from '../../../../recoil/states/default'
import { hexToRgba } from '../../../../utils/hexToRgba'
import Carousel from './carousel'
import useHome from '../../context/useHome'
import bg_cord from '../../../../assets/images/home/bg_cord.jpg'

const Scope2 = () => {
    const theme = useRecoilValue(themeState)
    const { homeData } = useHome()
    const bg = bg_cord//'https://redcross.or.th/wp-content/uploads/2017/10/BG_cord.jpg?id=128'
    const Banner = styled.div`
        background: linear-gradient(0deg, ${hexToRgba(theme.primary)}, ${hexToRgba(theme.primary)}), url(${bg});
        object-fit: cover;
        background-size: cover;
    `
    const isMobile = window.innerWidth <= 992

    return (
        <>
            {homeData && homeData.jobListJobReqListRemain && homeData.jobListJobReqListRemain.length > 0 &&
                <>
                    {isMobile &&
                        <div className='home-scope2-mobile'>
                            <div className="title-mobile px-3 py-2">
                                <div className="title">ประกาศงานที่ใกล้ปิดรับสมัคร</div>
                            </div>
                        </div>}
                    <Banner className='home-scope2'>
                        {!isMobile && <div className="container margin-auto div-title flex justify-between items-center px-3">
                            <div className="title">ประกาศงานที่ใกล้ปิดรับสมัคร</div>
                        </div>
                        }
                        <div className="div-carousel relative">
                            <Carousel />
                        </div>
                    </Banner>
                </>
            }
        </>
    )
}

export default Scope2